import { CalendarOutlined, DollarOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import moment from "moment";
import React from "react";
import {
  Loading,
  RedemptionsRequest,
} from "../../../helpers/shared-interfaces";
import {
  formatter,
  generateNameFromCustomer,
} from "../../../helpers/utilities";
import { ItemClickProps } from "../GlobalFormModal";
import NoData from "../NoData";

type Props = {
  loading: Loading;
  handleRetry: () => void;
  redemptions: RedemptionsRequest[];
  onRedemptionClick: (item: ItemClickProps) => void;
};

export default function Redemptions({
  redemptions,
  loading,
  handleRetry,
  onRedemptionClick,
}: Props): JSX.Element {
  return (
    <div className="global-results">
      {loading === Loading.INITIAL ? null : loading === Loading.LOADING ? (
        <div className="loading-container">
          <div className="loading-spinner">
            <Spin size="default" />
          </div>
        </div>
      ) : loading === Loading.ERROR ? (
        <div className="error-container">
          <p>Something went wrong</p>
          <button onClick={handleRetry}>Try again</button>
        </div>
      ) : redemptions.length === 0 ? (
        <div className="no-results">
          <NoData />
          <p>No Data</p>
        </div>
      ) : (
        redemptions.map((redemption) => (
          <div
            key={redemption.id}
            className="search-result"
            role="presentation"
            onClick={() =>
              onRedemptionClick({
                id: redemption.id,
                type: "redemption",
                segment: "redemption-requests",
                data: redemption,
              })
            }
          >
            <div className="result-content">
              <div className="result-title">
                {generateNameFromCustomer(redemption.customer)}
              </div>
              <div className="result-details">
                <CalendarOutlined />{" "}
                {moment(redemption.requestDate, "YYYY-MM-DD HH:mm:ss").format(
                  "DD/MM/YYYY",
                )}{" "}
                {" / "}
                <DollarOutlined />{" "}
                {formatter.format(redemption?.redemptionAmount)}
              </div>
            </div>
            <span className="right-arrow">→</span>
          </div>
        ))
      )}
    </div>
  );
}
